import React, { useState } from "react";
import "../styles/Contact.css";
import "../styles/MainContent.css";

const ContactSection = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    alert(`Thank you! Your email ${email} has been submitted.`);
    setEmail("");
  };

  return (
    <section className="contact-section" aria-labelledby="contact-heading">
      <h2 id="contact-heading">CONTACT US</h2>
      <p>Any questions? Talk to our developers</p>
      <form method="POST" onSubmit={handleSubmit} aria-label="Contact Form">
        <label htmlFor="email" className="visually-hidden">
          Email:
        </label>
        <input
          id="email"
          type="email"
          placeholder="Enter your email..."
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
          aria-required="true"
        />
        <button type="submit">Submit</button>
      </form>
    </section>
  );
};

export default ContactSection;
